import React, { forwardRef } from "react";

import { StyledColumns } from "./Styles";
import { Breakpoint } from "../BreakPoints";
import { Align, Space } from "../LayoutTokens";

export interface IColumnsProps extends React.ComponentPropsWithoutRef<"div"> {
  widths?: number[];
  space?: Space;
  alignY?: Align;
  collapseBelow?: Breakpoint;
}

export const Columns = forwardRef<HTMLDivElement, IColumnsProps>(
  (
    {
      widths,
      space = "lg",
      alignY = "stretch",
      collapseBelow,
      children,
      ...rest
    },
    ref
  ) => (
    <StyledColumns
      ref={ref}
      $space={space}
      $alignY={alignY}
      $collapse={collapseBelow}
      {...rest}
    >
      {React.Children.toArray(children).map((child, index) => (
        <div
          className="c-columns-col"
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          style={{ flex: `${widths?.[index] ?? 1} 1 0` }}
        >
          {child}
        </div>
      ))}
    </StyledColumns>
  )
);

Columns.displayName = "Columns";
